<template>
  <div class="view-home">
    <div class="container">
      <div class="about-test-block">
        <h2 v-if="$i18n.locale == 'ru'" class="title">О предмете №{{ (Number(currentSubjectIndex) || 0) + 1 }}</h2>
        <h2 v-if="$i18n.locale == 'kz'" class="title">№{{ (Number(currentSubjectIndex) || 0) + 1 }} пән туралы</h2>
        <p v-if="$i18n.locale == 'ru'" class="subtitle">{{ (Number(currentSubjectIndex) || 0) + 1 }} предмет из {{ (quizData && quizData.subjects && quizData.subjects.length) || 0 }}</p>
        <p v-if="$i18n.locale == 'kz'" class="subtitle">{{ (quizData && quizData.subjects && quizData.subjects.length) || 0 }} пәннің {{ (Number(currentSubjectIndex) || 0) + 1 }}</p>

        <div class="test-card">
          <div class="test-card-header">
            {{currentSubject.subject_data[`name_${test_lang}`]}}
          </div>
          <p class="test-card-text" v-if="currentSubject.subject_data.id == 1" v-html="$t('subject-desc-math')">
          </p>
          <p class="test-card-text" v-else-if="currentSubject.subject_data.id == 10" v-html="$t('subject-desc-eng')">
          </p>
          <p class="test-card-text" v-else-if="currentSubject.subject_data.id == 13" v-html="$t('subject-desc-nat')">
          </p>
          <p class="test-card-text" v-else v-html="$t('subject-desc-lang')">
          </p>
<!--          <p class="test-card-text">-->
<!--            {{$t('about_page_2')}}-->
<!--          </p>-->
<!--          <p class="test-card-text">-->
<!--            {{$t('about_page_3')}}-->
<!--          </p>-->
        </div>

        <div class="info-boxes">
          <div class="info-box">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path fill-rule="evenodd" clip-rule="evenodd" d="M11.4794 0.0735878C11.3699 0.113668 11.2021 0.205985 11.1066 0.278719C10.9415 0.404504 10.6635 0.745084 10.6206 0.874276C10.6065 0.916544 10.3129 0.942891 9.63689 0.962473C8.78354 0.987193 8.64356 1.00352 8.41353 1.1053C8.0911 1.24797 7.77249 1.56693 7.61876 1.90095C7.50711 2.14357 7.50095 2.22017 7.48536 3.56672L7.46906 4.97817H12.0096H16.5502L16.5339 3.56672C16.5183 2.21966 16.5122 2.14342 16.4 1.89592C16.2531 1.57187 15.9328 1.25438 15.6007 1.10342C15.3718 0.9994 15.2517 0.985769 14.4144 0.968933L13.4828 0.950215L13.2817 0.678453C13.0415 0.353742 12.8184 0.175365 12.5219 0.0708921C12.2504 -0.0247307 11.7446 -0.0234083 11.4794 0.0735878ZM4.00336 2.56624C3.65317 2.67382 3.2307 3.07813 3.0978 3.4328C2.99287 3.71285 2.99277 3.72465 3.00602 13.3358L3.01926 22.9583L3.13422 23.1731C3.29427 23.4722 3.57371 23.7368 3.87999 23.8792L4.13987 24H12.0096H19.8794L20.1393 23.8792C20.4456 23.7368 20.725 23.4722 20.885 23.1731L21 22.9583V13.2434V3.52857L20.8879 3.31937C20.7348 3.03362 20.3109 2.66487 20.0228 2.56685C19.8331 2.50231 19.5541 2.48588 18.6478 2.48588H17.5108V4.24066V5.99544H12.0096H6.50844V4.24066V2.48588L5.37509 2.48944C4.54141 2.49203 4.17874 2.51233 4.00336 2.56624ZM9.80411 7.08915C9.86422 7.13122 9.9396 7.24479 9.97154 7.34153C10.0192 7.48573 10.0147 7.54763 9.94674 7.68471C9.89289 7.79325 9.30875 8.3118 8.28298 9.16167C6.30989 10.7965 6.54206 10.736 5.653 9.84609C5.13783 9.33049 5.02292 9.18797 4.99785 9.03365C4.97091 8.86794 4.98802 8.82593 5.14705 8.66713C5.45512 8.35951 5.68953 8.43403 6.21107 9.00547C6.47508 9.29473 6.50732 9.31523 6.59274 9.24794C6.64403 9.2075 7.22482 8.7271 7.88338 8.18047C8.54194 7.63379 9.13745 7.14739 9.20672 7.09963C9.36228 6.99226 9.65818 6.98707 9.80411 7.08915ZM18.5296 7.9791V8.48774H15.2696H12.0096V7.9791V7.47047H15.2696H18.5296V7.9791ZM18.5296 9.9882V10.4714H15.2696H12.0096V9.9882V9.505H15.2696H18.5296V9.9882ZM9.80941 12.1239C9.9882 12.2741 10.0381 12.4739 9.94938 12.684C9.88036 12.8473 6.8676 15.3923 6.64408 15.476C6.57736 15.501 6.45704 15.505 6.37672 15.4849C6.21173 15.4435 5.16956 14.4487 5.04782 14.2164C4.8753 13.8871 5.11389 13.5232 5.50244 13.5232C5.68586 13.5232 5.7425 13.5595 6.09774 13.9047C6.31361 14.1145 6.50813 14.2861 6.52988 14.2861C6.55169 14.2861 7.15748 13.7978 7.8761 13.2008C8.59466 12.6038 9.22847 12.0896 9.2845 12.0579C9.45071 11.964 9.6488 11.989 9.80941 12.1239ZM18.5296 13.0146V13.5232H15.2696H12.0096V13.0146V12.5059H15.2696H18.5296V13.0146ZM18.5296 14.9982V15.5069H15.2696H12.0096V14.9982V14.4896H15.2696H18.5296V14.9982ZM9.80411 17.1092C9.94984 17.2111 10.0403 17.4905 9.97862 17.6485C9.91424 17.8135 9.80686 17.9094 8.14255 19.2904C6.33164 20.7929 6.54328 20.7432 5.66212 19.8733C5.24419 19.4607 5.02511 19.2058 5.00336 19.107C4.9163 18.7112 5.34718 18.3802 5.70954 18.5643C5.77072 18.5954 5.98201 18.7787 6.17898 18.9717L6.53722 19.3225L7.91084 18.1785C9.19862 17.1061 9.29734 17.0345 9.48963 17.0337C9.6025 17.0332 9.74401 17.0671 9.80411 17.1092ZM18.5296 17.9992V18.5078H15.2696H12.0096V17.9992V17.4905H15.2696H18.5296V17.9992ZM18.5296 20.0083V20.4915H15.2696H12.0096V20.0083V19.5251H15.2696H18.5296V20.0083Z" fill="#3E79FB"/>
            </svg>

            {{questionCount}} {{$t('page_rules_22')}}
          </div>
          <div class="info-box">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <g clip-path="url(#clip0_8097_18191)">
                <path fill-rule="evenodd" clip-rule="evenodd" d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24ZM12 22.0065C6.47356 22.0065 1.99349 17.5264 1.99349 12C1.99349 6.47356 6.47356 1.99349 12 1.99349C17.5264 1.99349 22.0065 6.47356 22.0065 12C22.0065 17.5264 17.5264 22.0065 12 22.0065ZM16.5765 5.16088C15.2284 4.26009 13.6434 3.7793 12.022 3.7793V11.9771H3.82422C3.82422 13.5985 4.30501 15.1834 5.2058 16.5316C6.10658 17.8797 7.38691 18.9304 8.88486 19.5509C10.3828 20.1714 12.0311 20.3337 13.6213 20.0174C15.2116 19.7011 16.6723 18.9203 17.8187 17.7738C18.9652 16.6273 19.746 15.1666 20.0623 13.5764C20.3786 11.9862 20.2163 10.3379 19.5958 8.83994C18.9753 7.34198 17.9246 6.06166 16.5765 5.16088Z" fill="#3E79FB"/>
              </g>
              <defs>
                <clipPath id="clip0_8097_18191">
                  <rect width="24" height="24" fill="white"/>
                </clipPath>
              </defs>
            </svg>

            {{remainingTime}} минут
          </div>
        </div>

        <p class="footer-text">{{$t('page_rules_23')}}</p>

        <button class="test-next-btn" @click="startTest" style="margin: 0 auto" :class="{ disabled: !$store.state.proctoring.permissionWebContents }">
          {{$t('page_rules_24')}}
          <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M12.675 21.9508L22.1226 12.5008L12.6726 3.05078M1.875 12.5008H22.125H1.875Z" stroke="#FBFBFD"
                  stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </button>
      </div>
    </div>

    <div class="main-wrapper-mobile">
      <div class="page-header-mobile">
        <div class="start-test-title-mobile" v-if="$i18n.locale == 'ru'">
          О предмете №{{ (Number(currentSubjectIndex) || 0) + 1 }}
        </div>
        <div class="start-test-title-mobile" v-if="$i18n.locale == 'kz'">
          №{{ (Number(currentSubjectIndex) || 0) + 1 }} пән туралы
        </div>
      </div>
      <div class="middle-wrapper-mobile">
        <div class="about-subject-block">
          <p v-if="$i18n.locale == 'ru'">
            {{ (Number(currentSubjectIndex) || 0) + 1 }} предмет из {{ (quizData && quizData.subjects && quizData.subjects.length) || 0 }}
          </p>
          <p v-if="$i18n.locale == 'kz'">
            {{ (quizData && quizData.subjects && quizData.subjects.length) || 0 }} пәннің {{ (Number(currentSubjectIndex) || 0) + 1 }}
          </p>
          <p>
            {{currentSubject.subject_data[`name_${test_lang}`]}}
          </p>
          <div class="test-desc-questions-time-mobile">
            <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
              <circle cx="20" cy="20" r="20" fill="#3377FF"/>
              <path d="M25.2704 28.1604H14.9504C14.2304 28.1604 13.6504 27.5804 13.6504 26.8604V13.9504C13.6504 13.2304 14.2304 12.6504 14.9504 12.6504H25.2704C25.9904 12.6504 26.5704 13.2304 26.5704 13.9504V26.8604C26.5704 27.5804 25.9904 28.1604 25.2704 28.1604Z" stroke="white" stroke-width="1.2" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
              <path d="M17.0703 18.4297H21.1503" stroke="white" stroke-width="1.2" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
              <path d="M17.0703 22.3789H23.1503" stroke="white" stroke-width="1.2" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>


            <div class="test-desc-text-mobile">
              <p class="title">
                {{questionCount}} {{$t('page_rules_22')}}
              </p>
              <p class="subtitle">
                {{$t('page_rules_25')}}
              </p>
            </div>
          </div>

          <div class="test-desc-questions-time-mobile">
            <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
              <circle cx="20" cy="20" r="20" fill="#3377FF"/>
              <path d="M20.4596 29.3196C25.3529 29.3196 29.3196 25.3529 29.3196 20.4596C29.3196 15.5664 25.3529 11.5996 20.4596 11.5996C15.5664 11.5996 11.5996 15.5664 11.5996 20.4596C11.5996 25.3529 15.5664 29.3196 20.4596 29.3196Z" stroke="white" stroke-width="1.2" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
              <path d="M20.4609 15.6191V20.4591L23.4409 21.8791" stroke="white" stroke-width="1.2" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>

            <div class="test-desc-text-mobile">
              <p class="title">
                {{remainingTime}} минут
              </p>
              <p class="subtitle">
                {{$t('page_rules_26')}}
              </p>
            </div>
          </div>

          <div class="about-subject-desc">
            <p v-if="currentSubject.subject_data.id == 1" v-html="$t('subject-desc-math')">
            </p>
            <p v-else-if="currentSubject.subject_data.id == 10" v-html="$t('subject-desc-eng')">
            </p>
            <p v-else-if="currentSubject.subject_data.id == 13" v-html="$t('subject-desc-nat')">
            </p>
            <p v-else v-html="$t('subject-desc-lang')">
            </p>
<!--            <p>-->
<!--              {{$t('about_page_2')}}-->
<!--            </p>-->
<!--            <p>-->
<!--              {{$t('about_page_3')}}-->
<!--            </p>-->
          </div>

        </div>

        <div class="ready-start-label-mobile">
          {{$t('page_rules_23')}}
        </div>

        <button class="next-btn-mobile" @click="startTest">
          {{$t('page_rules_24')}}
          <svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M13.425 21.4508L22.8726 12.0008L13.4226 2.55078M2.625 12.0008H22.875H2.625Z" stroke="#FBFBFD"
                  stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>

        </button>

      </div>
    </div>
  </div>
</template>
<script>
import Vue from "vue";

export default {
  name: "AboutSubject",
  components: {},
  data() {
    return {
      currentSubject: {
        subject_data: {
          name_ru: '',
          name_kz: '',
        }
      },
      test_lang: 'ru',
      subject_id: this.$route.params.id,
      quizData: {
        subjects: []
      },
      currentSubjectIndex: 0,
      currentQuizSubject: {
        questions: [],
      },
      remainingTime: 0,
      questionCount: 0,

    }
  },
  methods: {
    getTest() {
      const quizToken = localStorage.getItem('quiz-token');

      if (!quizToken) {
        console.error('Quiz token not found');
        return;
      }

      this.$http.get(API_ROOT + `/api/quiz/${quizToken}/${this.subject_id}/start`)
          .then(res => {

            if (!res.body) {
              console.error('Empty response body');
              return;
            }

            const resData = res.body

            // Достаем данные данные по всему квизу
            this.quizData = JSON.parse(localStorage.getItem('quiz-data') || 'null');

            // Проверка данных из localStorage
            if (!this.quizData || !Array.isArray(this.quizData.subjects)) {
              console.error('Invalid quiz data');
              return;
            }

            // Добавляем данные по текущему тесту
            resData['subject_data'] = this.quizData.subjects.find(item => item.id == this.subject_id)
            this.currentSubject = resData

            console.log('this.currentSubject', this.currentSubject)

            // Для вывода времени теста
            this.remainingTime = Number(this.currentSubject.time)
            this.questionCount = this.currentSubject?.questions?.length

            this.currentSubjectIndex = this.quizData.subjects.findIndex(item => item.id == this.subject_id);
            this.currentQuizSubject = res.body
            localStorage.setItem('timer', Number(this.currentQuizSubject.time) * 60);

            if (res.body) {
              localStorage.setItem('current-quiz-subject', JSON.stringify(res.body));
              localStorage.setItem('test_lang', res.body.test_language);
            }
          })
    },
    startTest() {
      const nextId = this.currentSubject.questions[0].id;

      const canStartTest = window.innerWidth <= 1000 || this.$store.state.proctoring.permissionWebContents;

      if (canStartTest) {
        this.$router.push({ name: 'test-page', params: { id: nextId } });
      }

    },
  },
  computed: {

  },
  mounted() {

    this.getTest()

    if (localStorage.getItem('test_lang')) {
      this.test_lang = localStorage.getItem('test_lang');
      this.$i18n.locale = this.test_lang;
    }

    if (localStorage.getItem('current-subject-index')) {
      let currentSubjectIndex = Number(localStorage.getItem('current-subject-index'))
      currentSubjectIndex += 1
      localStorage.setItem('current-subject-index', currentSubjectIndex + '')
    } else {
      localStorage.setItem('current-subject-index', '0')
    }
  },
}
</script>
<style>


</style>
